import * as fromAuth from './reducers/auth.reducer';
import * as fromClients from './reducers/clients.reducers';

import { ActionReducer, ActionReducerMap, combineReducers, compose } from '@ngrx/store';

import { InjectionToken } from '@angular/core';

export interface AuthState {
  user: fromAuth.AuthState;
}

export interface ClientsState {
  clients: fromClients.ClientsState;
}

export const Auth_REDUCER_TOKEN = new InjectionToken<ActionReducerMap<AuthState>>('Auth Reducers');

export const CLIENTS_REDUCER_TOKEN = new InjectionToken<ActionReducerMap<ClientsState>>(
  'Clients Reducers',
);

export function getAuthReducers(): ActionReducerMap<AuthState> | any {
  // map of reducers
  return { user: fromAuth.AuthReducer };
}

export function getClientsReducers(): ActionReducerMap<ClientsState> | any {
  // map of reducers
  return { clients: fromClients.reducer };
}
